(function () {
  'use strict';
  if (window.WynchMetaPendingV1) return;
  // Presentation only. Never write a consent flag, enrollment receipt or claim token.
  var key = 'wynch_meta_pending_hint_v1';
  var params = new URLSearchParams(location.search);
  var active = false;
  try { active = localStorage.getItem(key) === 'pending'; } catch (_) {}
  if (params.get('newsletter_state') === 'pending' && params.get('source') === 'meta') {
    active = true;
    try { localStorage.setItem(key, 'pending'); } catch (_) {}
    // Do not copy the hint into internal links or a later DOI return URL.
    params.delete('newsletter_state'); params.delete('source');
    history.replaceState(history.state, '', location.pathname + (params.size ? '?' + params : '') + location.hash);
  }
  var nativeSelector = '[data-wynch-article-club-native]';
  var formSelector = '[data-wynch-cart-club-form], [data-subscribe-form], [data-quiz-newsletter-form], [data-wynch-doi-popup-form]';
  var de = (document.documentElement.lang || 'de').toLowerCase().indexOf('en') !== 0;
  var copy = de ? {
    title: 'Bestätige deine E-Mail',
    body: 'Öffne die Bestätigungs-E-Mail von WYNCH und bestätige deine Anmeldung. Prüfe auch den Spam-Ordner.',
    resend: 'E-Mail erneut anfordern', change: 'Andere E-Mail verwenden',
    email: 'Gib deine E-Mail-Adresse ein, um die Bestätigungs-E-Mail erneut anzufordern.'
  } : {
    title: 'Confirm your email',
    body: 'Open the confirmation email from WYNCH and confirm your subscription. Please also check your spam folder.',
    resend: 'Request email again', change: 'Use another email',
    email: 'Enter your email address to request the confirmation email again.'
  };
  var panels = new Map();
  function confirmed() {
    var global = document.querySelector('[data-wynch-club-global]');
    if (global && global.dataset.customerClubConfirmed === 'true') return true;
    if (document.querySelector(nativeSelector + '[data-server-confirmed="true"]')) return true;
    try {
      var value = JSON.parse(localStorage.getItem('wynch_article_club_confirmed_ui_v1') || sessionStorage.getItem('wynch_article_club_confirmed_ui_v1') || 'null');
      return Boolean(value && value.version === 1 && Number.isFinite(value.confirmedAt) && value.confirmedAt > 0 && value.confirmedAt <= Date.now());
    } catch (_) { return false; }
  }
  function clear() {
    active = false;
    try { localStorage.removeItem(key); } catch (_) {}
    render();
  }
  function resume(form, resend) {
    clear();
    if (resend) {
      var note = document.createElement('p');
      note.className = 'wynch-meta-pending-note'; note.setAttribute('role', 'status'); note.textContent = copy.email;
      form.before(note);
      form.addEventListener('submit', function () { note.remove(); }, { once: true });
    }
    var input = form.querySelector('input[type="email"]');
    if (input) input.focus();
  }
  function panelFor(form) {
    var panel = document.createElement('section');
    panel.className = 'wynch-meta-pending'; panel.dataset.metaPendingPanel = '';
    var title = document.createElement('h3'); title.textContent = copy.title;
    var body = document.createElement('p'); body.textContent = copy.body;
    panel.append(title, body);
    [copy.resend, copy.change].forEach(function (label, index) {
      var button = document.createElement('button'); button.type = 'button'; button.textContent = label;
      button.className = index ? 'wynch-meta-pending__change' : 'wynch-meta-pending__resend';
      button.addEventListener('click', function () { resume(form, index === 0); }); panel.append(button);
    });
    form.before(panel);
    var host = form.closest('[data-wynch-cart-club], .results-banner__content, [data-wynch-doi-popup]');
    var siblings = host ? Array.from(host.querySelectorAll('.wynch-cart-club__intro, .results-banner__title, .results-banner__text, #wynch-doi-popup-title, .wynch-doi-popup__copy')) : [];
    return { panel: panel, nodes: [form].concat(siblings).map(function (node) { return { node: node, hidden: node.hidden }; }) };
  }
  function render() {
    document.documentElement.classList.toggle('wynch-meta-doi-pending', active);
    document.querySelectorAll(nativeSelector).forEach(function (root) {
      if (active) root.setAttribute('data-meta-doi-hint', '');
      else root.removeAttribute('data-meta-doi-hint');
      // The native Article pending state supplies its existing envelope artwork.
    });
    if (active) document.querySelectorAll(formSelector).forEach(function (form) {
      if (!panels.has(form)) panels.set(form, panelFor(form));
    });
    panels.forEach(function (value, form) {
      if (!form.isConnected) { value.panel.remove(); panels.delete(form); return; }
      value.panel.hidden = !active;
      value.nodes.forEach(function (entry) {
        entry.node.hidden = active || entry.hidden;
        if (active) entry.node.setAttribute('data-meta-pending-hidden', '');
        else entry.node.removeAttribute('data-meta-pending-hidden');
      });
      if (!active) { value.panel.remove(); panels.delete(form); }
    });
  }
  function init() {
    if (confirmed()) clear();
    if (active && window.WynchClubFlowV1) window.WynchClubFlowV1.renderState({ state: 'pending' }, false, false);
    render();
    // AJAX cart and dynamically mounted subscription blocks use the same hint.
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches(formSelector + ', ' + nativeSelector) || node.querySelector(formSelector + ', ' + nativeSelector)); }); })) render();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () { observer.disconnect(); });
    window.addEventListener('pageshow', function () { observer.observe(document.body, { childList: true, subtree: true }); });
    document.addEventListener('click', function (event) {
      if (!active || !(event.target instanceof Element)) return;
      var button = event.target.closest('[data-club-resend], [data-club-restart]');
      if (!button || !button.closest(nativeSelector)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      var root = button.closest(nativeSelector), resend = button.hasAttribute('data-club-resend');
      clear();
      // Run the native entry action; do not resend against an unknown identity.
      var restart = root.querySelector('[data-club-restart]');
      if (restart) restart.click();
      if (resend) {
        var status = root.querySelector('[data-club-error]');
        if (status) { status.textContent = copy.email; status.hidden = false; }
      }
    }, true);
    ['wynch:club-confirmed', 'wynch:club-cava-verified'].forEach(function (name) { document.addEventListener(name, clear); });
    document.addEventListener('wynch:article-club-native', function (event) {
      if (event.detail && event.detail.event === 'native-club-state' && event.detail.state === 'confirmed') clear();
    });
    window.addEventListener('storage', function (event) {
      if (event.key === key) { active = event.newValue === 'pending' && !confirmed(); render(); }
      else if (event.key === 'wynch_article_club_confirmed_ui_v1' && confirmed()) clear();
    });
    window.addEventListener('wynch:club-enrollment-registered', function (event) {
      if (event.detail && event.detail.uiOnly && (event.detail.state === 'confirmed' || event.detail.state === 'claimed' || event.detail.state === 'entry')) clear();
    });
  }
  window.WynchMetaPendingV1 = Object.freeze({ isPending: function () { return active; }, clear: clear });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
